export default __webpack_public_path__ + "static/media/ban2.334ac2d1.jpeg";